export default function Bulb(props) {
    const fill = props.fill ?? '#ffffff';

    return (
        <svg
            width="17"
            height="17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.687 1.76a.8.8 0 00-1.6 0v.8a.8.8 0 101.6 0v-.8zM4.252 3.195a.8.8 0 00-1.13 1.131l.8.8a.8.8 0 001.13-1.131l-.8-.8zm10.4 1.131a.8.8 0 00-1.13-1.131l-.8.8a.8.8 0 001.13 1.131l.8-.8zM8.887 4.16a4.8 4.8 0 00-2.654 8.8h5.307a4.8 4.8 0 00-2.653-8.8zm2.4 9.6h-4.8v.8a2.4 2.4 0 104.8 0v-.8zm-9.6-5.6a.8.8 0 100 1.6h.8a.8.8 0 000-1.6h-.8zm13.6 0a.8.8 0 000 1.6h.8a.8.8 0 100-1.6h-.8z"
                fill={fill}
            />
        </svg>
    );
}
